<template>
  <section>
    <slot name="top"></slot>
    <div class="multiset">
      <label class="entry"
             v-for="e in list"
             :key="keyer(e)"
             :class="selected.includes(e.nom) ? 'selected' : ''">
        <input type="checkbox" :id="keyer(e)" :value="e" v-model="selection">
        <span>{{ view(e) }}</span>
        <span class="capital">{{ view(e) | initial }}</span>
        <slot v-bind:el="e"><span class="mini">({{ e.price }}€)</span></slot>
      </label>
    </div>
  </section>
</template>
<script>

export default {
props: {
    'init':{
        type: Array,
        required: true
    },
    'list':{
        type: Array,
        required: true
    },
    'view':{
        type: Function,
        required: true,
    },
    'keyer':{
        type: Function,
        required: true,
    },
    'cb':{
        type: Function,
        required: true,
    },
},
    computed: { selected () { return this.selection.map(s => s.nom) } },
    watch: {
      selection: function () { this.cb(this.selection); }
    },
    data () {
      return { selection: this.init };
    }
}

</script>
<style>
  .multiset {
    margin: 0.3em;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 0.3em;
  }

  .multiset input {
    display: none;
  }
  
  .entry {
    border: thin solid #7575750a;
    background-color: #b7b7b71c;
    overflow: hidden;
    min-height: 4em;
  }

  label.entry {
    position: relative;
    cursor: pointer;
  }

  label.entry.selected {
    border-bottom: thin solid deeppink;
  }

  .entry .mini {
opacity: 50%;
font-size: 6pt;
bottom: 0;
position: absolute;
left: 0;
  }



  :checked + span {
  color: deeppink;
  font-weight: bold;
  }

  :checked ~ span {
  font-weight: bold;
  }

  .capital {
  position: absolute;
  margin: 0 2px;
  bottom: 0;
  right: 0;
  opacity: 0.5;
  font-size: 6pt;
  }

</style>
